export const capitalizeFirstLetter = (string) => {
  return typeof string === 'string'
    ? string.charAt(0).toUpperCase() + string.slice(1)
    : string;
};

export const getFullName = (firstName, lastName) =>
  [firstName || '', lastName || ''].filter((_) => _).join(' ');

export const getReadableFileSizeString = (fileSizeInBytes) => {
  var i = -1;
  var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
  do {
    fileSizeInBytes = fileSizeInBytes / 1024;
    i++;
  } while (fileSizeInBytes > 1024);

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};

export const separateCost = (number = 0, characterSeparator = ',') => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, characterSeparator);
};

export const objectToQueryString = (obj) => {
  return Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};

export const getDeleteTitle = (str) => {
  return `Delete ${str}`;
};

export const getDeleteContent = (str) => {
  return (
    <>
      Are you sure to delete <b>{str}</b>?
    </>
  );
};

export const getFileExtension = (filename) => {
  return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
};

export const formatNumber = (number, options = {}) =>
  isNaN(number) ? '' : new Intl.NumberFormat('en-US', options).format(number);

export const formatCurrency = (number, options) =>
  formatNumber(
    number,
    options ? options : { style: 'currency', currency: 'USD' }
  );

export const compareStr = (str1, str2) => {
  if (typeof str1 !== 'string' || typeof str2 !== 'string') return null;

  return str1.trim().toLowerCase() === str2.trim().toLowerCase();
};

export const formatFloatNumber = (value) => {
  if (!value) return 0;
  if (typeof value === 'string') return parseFloat(value.replace(/,/g, ''));

  return value;
};

export const checkHaveDecimal = (number) => {
  return number - Math.floor(number) !== 0;
};
